import { environment } from "../../environments/environment";

export const ApiEndpoints = {
  log: {
    getAll: () => `${environment.baseUrl}/Log`,
    post: () => `${environment.baseUrl}/Log/`,
    get: (id) => `${environment.baseUrl}/Log/${id}`,
    put: (id) => `${environment.baseUrl}/Log/${id}`,
    delete: (id) => `${environment.baseUrl}/Log/${id}/`,
  },
  group: {
    getAll: () => `${environment.baseUrl}/Group`,
    post: () => `${environment.baseUrl}/Group/`,
    get: (id) => `${environment.baseUrl}/Group/${id}`,
    put: (id) => `${environment.baseUrl}/Group/${id}`,
    delete: (id) => `${environment.baseUrl}/Group/${id}/`,
  },
  sensorData: {
    get: (id, date, granularity) => `${environment.baseUrl}/SensorData/${id}/${date}/${granularity}`,
  },
  holidays: {
    getAll: () => `${environment.baseUrl}/Holidays`,
    post: () => `${environment.baseUrl}/Holidays/`,
    get: (id) => `${environment.baseUrl}/Holidays/${id}`,
    put: (id) => `${environment.baseUrl}/Holidays/${id}`,
    delete: (id) => `${environment.baseUrl}/Holidays/${id}/`,
    enableOrDisable: (id) => `${environment.baseUrl}/Holidays/enableOrDisable/${id}`,
  },
  accessDevice: {
    getAll: () => `${environment.baseUrl}/AccessDevice`,
    post: () => `${environment.baseUrl}/AccessDevice/`,
    get: (id) => `${environment.baseUrl}/AccessDevice/${id}`,
    getByIdentifier: (id) => `${environment.baseUrl}/AccessDevice/identifier/${id}`,
    put: () => `${environment.baseUrl}/AccessDevice/`,
    delete: (id) => `${environment.baseUrl}/AccessDevice/${id}/`,
  },
  rule: {
    getAll: () => `${environment.baseUrl}/Rule`,
    getPairedRules: () => `${environment.baseUrl}/Rule/PairedRule`,
    post: () => `${environment.baseUrl}/Rule/`,
    get: (id) => `${environment.baseUrl}/Rule/${id}`,
    put: (id) => `${environment.baseUrl}/Rule/${id}`,
    enableOrDisable: (id) => `${environment.baseUrl}/Rule/enableOrDisable/${id}`,
    delete: (id) => `${environment.baseUrl}/Rule/${id}/`,
  },
  automationRule: {
    getAll: () => `${environment.baseUrl}/AutomationRules`,
    post: () => `${environment.baseUrl}/AutomationRules/`,
    get: (id) => `${environment.baseUrl}/AutomationRules/${id}`,
    put: (id) => `${environment.baseUrl}/AutomationRules/${id}`,
    enableOrDisable: (id) => `${environment.baseUrl}/AutomationRules/enableOrDisable/${id}`,
    delete: (id) => `${environment.baseUrl}/AutomationRules/${id}/`,
  },
  sensorAutomation: {
    getAll: () => `${environment.baseUrl}/SensorAutomation`,
    post: () => `${environment.baseUrl}/SensorAutomation/`,
    get: (id) => `${environment.baseUrl}/SensorAutomation/${id}`,
    put: (id) => `${environment.baseUrl}/SensorAutomation/${id}`,
    enableOrDisable: (id) => `${environment.baseUrl}/SensorAutomation/enableOrDisable/${id}`,
    delete: (id) => `${environment.baseUrl}/SensorAutomation/${id}/`,
  },
  command: {
    getAll: () => `${environment.baseUrl}/Command`,
    post: () => `${environment.baseUrl}/Command/`,
    get: (id) => `${environment.baseUrl}/Command/${id}`,
    put: (id) => `${environment.baseUrl}/Command/${id}`,
    enableOrDisable: (id) => `${environment.baseUrl}/Command/enableOrDisable/${id}`,
    delete: (id) => `${environment.baseUrl}/Command/${id}/`,
  },
  blinder: {
    getAll: () => `${environment.baseUrl}/BlinderOptions`,
    post: () => `${environment.baseUrl}/BlinderOptions/`,
    get: (id) => `${environment.baseUrl}/BlinderOptions/${id}`,
    put: (id) => `${environment.baseUrl}/BlinderOptions/${id}`,
    delete: (id) => `${environment.baseUrl}/BlinderOptions/${id}/`,
  },
  dashboard: {
    getAll: () => `${environment.baseUrl}/Dashboard`,
    get: (id) => `${environment.baseUrl}/Dashboard/${id}/`
  },
  device: {
    getAll: () => `${environment.baseUrl}/Device`,
    getAllByType: (type) => `${environment.baseUrl}/Device?type=${type}`,
    post: () => `${environment.baseUrl}/Device/`,
    getDeviceMqtt: () => `${environment.baseUrl}/DeviceMqtt/`,
    get: (id) => `${environment.baseUrl}/Device/${id}`,
    put: (id) => `${environment.baseUrl}/Device/${id}`,
    delete: (id) => `${environment.baseUrl}/Device/${id}/`,
    setOptionGroup: () => `${environment.baseUrl}/Device/options/group`,
    deleteOptionGroup: () => `${environment.baseUrl}/Device/options/group/delete`,
    changeGroup: () => `${environment.baseUrl}/Device/options/group/change`,
    getGroupOptionById: (id) => `${environment.baseUrl}/Device/options/group/${id}/`,
    editOptionGroup: () => `${environment.baseUrl}/Device/options/group/edit`,
  },
  configuration: {
    get: () => `${environment.baseUrl}/Configuration`,
    put: () => `${environment.baseUrl}/Configuration`,
  },
  blinder_options: {
    getAll: () => `${environment.baseUrl}/BlinderOptions`,
    post: () => `${environment.baseUrl}/BlinderOptions/`,
    get: (id) => `${environment.baseUrl}/BlinderOptions/${id}`,
    put: (id) => `${environment.baseUrl}/BlinderOptions/${id}`,
    delete: (id) => `${environment.baseUrl}/BlinderOptions/${id}/`,
  },
  paired: {
    getAll: () => `${environment.baseUrl}/Paired`,
    post: () => `${environment.baseUrl}/Paired/`,
    get: (id) => `${environment.baseUrl}/Paired/${id}`,
    put: (id) => `${environment.baseUrl}/Paired/${id}`,
    delete: (id) => `${environment.baseUrl}/Paired/${id}/`
  },
  user: {
    getAll: () => `${environment.baseUrl}/Users`,
    get: (id) => `${environment.baseUrl}/Users/${id}`,
    put: (id) => `${environment.baseUrl}/Users/${id}`,
    delete: (id) => `${environment.baseUrl}/Users/${id}/`,
    register: () => `${environment.baseUrl}/Users/Register`,
    login: () => `${environment.baseUrl}/Users/Login/`,
    sendPasswordResetLink: () => `${environment.baseUrl}/users/recover-password`,
    resetPassword: () => `${environment.baseUrl}/users/reset-password`
  },
  switch: {
    switch: (identifier, btn, parameter) => `${environment.baseUrl}/Switch/${identifier}/${btn}/${parameter}`,
    switchBlinder: (identifier, btn, percentage) => `${environment.baseUrl}/SwitchBlinder/${identifier}/${btn}/${percentage}`,
    dimmer: (identifier, position) => `${environment.baseUrl}/Switch/${identifier}/${position}`
  }

};
